import React from 'react'
import {useTranslation} from 'react-i18next'
import {KTSVG} from 'app/utils/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap-v5'
import './style.scss'
import {Languages} from 'app/utils/common/constants'
import {useAppSelector} from 'setup/redux/Hooks'
import {selectLanguage} from 'app/modules/auth'

interface ServicesPageHeaderProps {
  onLoadB8akServices?: () => void
  onAddServiceCategory?: () => void
  addServiceLabelKey?: string
}

const ServicesPageHeader: React.FC<ServicesPageHeaderProps> = ({
  onLoadB8akServices,
  onAddServiceCategory,
  addServiceLabelKey = 'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.ADD_SERVICE_CATEGORY',
}) => {
  const {t} = useTranslation()
  const language = useAppSelector(selectLanguage)
  const rtlMode = language === Languages.ar

  return (
    <div className='services-page-header'>
      <h1 className='services-page-header__title'>
        {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.PAGE_TITLE')}
      </h1>

      <div className='services-page-header__actions'>
        <button
          type='button'
          className='services-page-header__btn-secondary'
          onClick={onAddServiceCategory}
        >
          <span className='services-page-header__plus' aria-hidden='true'>
            +
          </span>
          {t(addServiceLabelKey)}
        </button>

        <OverlayTrigger
          placement={rtlMode ? 'top-start' : 'top-end'}
          trigger={['hover', 'focus']}
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [rtlMode ? -5 : 5, 8],
                },
              },
            ],
          }}
          overlay={
            <Tooltip id='load-b8ak-services-tooltip' className='load-b8ak-tooltip'>
              {t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.LOAD_B8AK_SERVICES')}
            </Tooltip>
          }
        >
          <button
            type='button'
            className='services-page-header__btn-icon'
            onClick={onLoadB8akServices}
            aria-label={t('SERVICE_MANAGEMENT_PAGE.FIRST_RUN.LOAD_B8AK_SERVICES')}
          >
            <KTSVG defaultColor={true} path='/assets/images/icons/bolt.svg' />
          </button>
        </OverlayTrigger>
      </div>
    </div>
  )
}

export default ServicesPageHeader
